import LabelValue from "../search/result/label-value";
import PropTypes from "prop-types";
import React from "react";
import Represented from "./represented";
import SlideShow from "../search/result/mini-slideshow/";
import SoldPrice from "./sold-price";
import Linkify from "../shared/linkify";

const Sold = ({ listing, filter, index }) => {
  const address = listing.showAddress
    ? `${listing.address1}${
        listing.address2 && listing.address2.trim().length > 0
          ? ", " + listing.address2
          : ""
      }`
    : listing.title;
  const title = <Linkify to={listing.listingLink}>{address}</Linkify>;
  if (!listing.hasImages) {
    listing.images = '["/img/s-grey.png"]';
  }

  return (
    <div className={"result-item three-col-sm col-xs-8 col-xxs-16"}>
      <div className="row" aria-label="listing" role="group">
        <div className="col-xs-16">
          <SlideShow
            listing={listing}
            link={listing.listingLink}
            sizes="(min-width: 561px) 50vw, (min-width: 768px) 32vw, (min-width: 1100px) 340px, 100vw"
            flagData={listing.listingType === "sale" ? ["Sold"] : ["Rented"]}
          />
        </div>
        <div className={"result-info col-xs-16"}>
          <h2 className="title">{title}</h2>
          <div className="header-standard fancy">
            {listing.cityStateCountry}
          </div>
          <div className="short-info">
            <ul>
              <LabelValue label="Bedrooms" value={listing.totalBedrooms} />
              <LabelValue
                label="Interior"
                value={listing.interiorSize
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                suffix="sq. ft. (approx.)"
              />
            </ul>
            <div>
              <SoldPrice listing={listing} />
              {listing.listingType !== "rental" ? (
                <Represented filter={filter} listing={listing} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Sold.propTypes = {
  filter: PropTypes.object.isRequired,
  listing: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default Sold;



// WEBPACK FOOTER //
// ./src/components/solds/sold.js